/** Single place for the API location. Relative by default: same-origin behind the ingress and the Vite proxy. */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1';

/** Items previewed inside each list card (0–10). Override with VITE_LIST_PREVIEW_ITEMS. */
export const LIST_PREVIEW_ITEMS = Number(import.meta.env.VITE_LIST_PREVIEW_ITEMS ?? 4);
